var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartEvaluation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.439 3.75L19.189 6l1.061 1.06 2.25-2.25-1.061-1.06zM12 15.375l-3.75-3.72 1.193-1.178L12 13.012 17.558 7.5l1.192 1.184L12 15.375z",
    fill: "#45464F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 21v-1.94l4.81-4.81-1.06-1.061L3 16.939V1.5H1.5V21A1.5 1.5 0 003 22.5h19.5V21H3z",
    fill: "#45464F"
  })));
}
export default SvgChartEvaluation;